module.exports = __webpack_public_path__ + "64b1f84312881f88ade76abb30831d64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/moonlight.jpg
// module id = 139
// module chunks = 0